import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { MenuService } from 'src/app/services/menu-service';

@Component({
  selector: 'app-devices-management',
  standalone: false,
  templateUrl: './devices-management.component.html',
  styleUrl: './devices-management.component.css'
})
export class DevicesManagementComponent implements OnInit, OnDestroy {
  isSavingData = false;
  loadingSub: Subscription | undefined;
  savingSub: Subscription | undefined;

  constructor(private menuService: MenuService,
                private data: DataService,
                private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      if (this.menuService.GetActiveMenuName() == 'Gestione Dispositivi') {
        if (status) {
          // this.data.refreshDevices().subscribe();
          // this.data.startPolling();
        }
      }
      else {
        //this.data.stopPolling();
      }
    });
    this.savingSub = this.menuService.savingStatusChanged.subscribe((status: boolean) => {
      this.isSavingData =  status;
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
    if (this.savingSub) {
      this.savingSub.unsubscribe();
    }
  }
}
